import { useEffect, useRef, useState } from 'react';

export const Lightbox = ({ isOpen, close, ...imageProps }) => {
  const closeButtonRef = useRef();

  useEffect(() => {
    if(isOpen) {
      closeButtonRef.current?.focus();
    }
  }, [closeButtonRef.current, isOpen]);

  return (
    <article
      className={`image-lightbox lightbox reverse${isOpen ? ' open' : ''}`}
      onClick={close}
    >
      <div className="overlay">
        <button
          className="close-lightbox"
          aria-label="close window"
          type="button"
          title="close window"
          ref={closeButtonRef}
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <div class="lightbox-content">
          <img {...imageProps} />
        </div>
      </div>
    </article>
  );
}

const LightboxImage = ({
  ...imageProps
}) => {
  const triggerRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const close = () => {
    setIsOpen(false);
    triggerRef.current?.focus();
  };

  return (
    <>
      <button
        className="lightbox-trigger"
        type="button"
        onClick={() => setIsOpen(true)}
        ref={triggerRef}
      >
        <img
          {...{
            ...imageProps,
            onClick: () => setIsOpen(true),
            className: imageProps.className
              ? imageProps.className.trim() + ' has-lightbox'
              : 'has-lightbox'
          }}
        />
      </button>
      <Lightbox
        isOpen={isOpen}
        close={close}
        {...imageProps}
      />
    </>
  );
};

export default LightboxImage;
